import { StrategyContent } from 'components/explorer/strategies/StrategyContent';

export const ExplorerStrategies = () => {
  return <StrategyContent url="/explore" />;
};
